import { MatchVideoList as MatchVideoListComponent } from './MatchVideoList.component';
import { connector } from './MatchVideoList.connector';

export const MatchVideoList = connector(MatchVideoListComponent);
